import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../screens/Login";
import {
  AUTHENTICATED_ROUTES,
  UNAUTHENTICATED_ROUTES,
} from "../constants/routeConstants";
import Home from "../screens/Home";
import Authenticated from "./Authenticated";
import AdvisorLogin from "../screens/AdvisorLogin";
import SignUp from "../screens/SignUp";
import AdvisorDashboard from "../screens/AdvisorDashboard";
import ArchivedCalls from "../screens/ArchivedCalls";
import TradeCall from "../screens/TradeCall";
import Edittrade from "../screens/Edittrade";
import AdvisorMyProfile from "../screens/AdvisorMyProfile";
import AdvisorAccount from "../screens/AdvisorAccount";
import OTPVerificatioForm from "../components/OTPVerification/OTPVerificatioForm";
import Terms from "../components/Home/Terms";
import Policy from "../components/Home/Policy";
import Disclosure from "../components/Home/Disclosure";
import Faqs from "../components/Home/Faqs";

import OnboardingForm from "../components/Onboarding/OnboardingForm";

const UnAuthenticated = ({ authenticated }) => {
  if (authenticated) {
    console.log("authenticated");
    return <Authenticated authenticated={authenticated} />;
  }
  return (
    <Routes>
      <Route path={UNAUTHENTICATED_ROUTES.HOME} element={<Home />} />
      <Route path={UNAUTHENTICATED_ROUTES.SIGN_IN} element={<Login />} />
      <Route
        path={UNAUTHENTICATED_ROUTES.ADVISOR_SIGN_IN}
        element={<AdvisorLogin />}
      />

      <Route path={UNAUTHENTICATED_ROUTES.SIGN_UP} element={<SignUp />} />
      <Route
        path={UNAUTHENTICATED_ROUTES.OTP_VERIFY}
        element={<OTPVerificatioForm />}
      />
      <Route
        path={UNAUTHENTICATED_ROUTES.ONBOARDING}
        element={<OnboardingForm />}
      />

      {/* <Route path={AUTHENTICATED_ROUTES.DASHBOARD} element={<Dashboard />} /> */}

      <Route
        path={AUTHENTICATED_ROUTES.ADVISOR_DASHBOARD}
        element={<AdvisorDashboard />}
      />
      <Route
        path={AUTHENTICATED_ROUTES.ADVISOR_ARCHIVED_CALLS}
        element={<ArchivedCalls />}
      />
      <Route
        path={AUTHENTICATED_ROUTES.ADVISOR_CREATE_CALL}
        element={<TradeCall />}
      />
      <Route
        path={AUTHENTICATED_ROUTES.ADVISOR_EDIT_CALL}
        element={<Edittrade />}
      />
      <Route
        path={AUTHENTICATED_ROUTES.ADVISOR_MY_PROFILE}
        element={<AdvisorMyProfile />}
      />
      <Route path="/account" element={<AdvisorAccount />} />

      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Policy />} />
      <Route path="/disclosure" element={<Disclosure />} />
      <Route path="/faqs" element={<Faqs />} />

      <Route path="*" element={<Home />} />
    </Routes>
  );
};

export default UnAuthenticated;
